<template>
  <v-dialog v-model="opened" width="800">
    <v-card>
      <v-card-title>
        <v-text-field
          :label="$t('activities.participantsList.search')"
          append-icon="mdi-magnify"
          hide-details
          single-line
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn @click="exportDownload()" title>
          <v-icon left>mdi-file-excel-box</v-icon> {{ $t("activities.participantsList.export") }}
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="participants"
        :loading="loading"
        :options.sync="pagination"
        :server-items-length="totalItems"
        item-key="id"
      ></v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from "../../../util/debounce";
import i18n from "../../../plugins/i18n";

const fileDownload = require("js-file-download");

export default {
  name: "ActivitiesEditParticipantsList",
  data() {
    return {
      currentActivity: null,
      participants: [],

      opened: false,
      headers: [
        { text: this.$t("activities.participantsList.firstName"), value: "firstName" },
        { text: this.$t("activities.participantsList.lastName"), value: "lastName" },
        {
          text: this.$t("activities.participantsList.username"),
          value: "username",
        },
        {
          text: this.$t("activities.participantsList.teamName"),
          value: "session.team.name",
          sortable: false,
        },
        {
          text: this.$t("activities.participantsList.teamSlug"),
          value: "session.team.slug",
          sortable: false,
        },
      ],
      pagination: {
        itemsPerPage: 25,
      },
      totalItems: 0,
      loading: true,
      search: "",
    };
  },
  methods: {
    open(activity) {
      this.currentActivity = activity;
      if (this.pagination.sortBy) this.loadData();
      this.opened = true;
    },
    async loadData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.loading = true;

      let result = await this.$axios.get(`admin/participants/${this.currentActivity.id}`, {
        params: {
          page: page - 1,
          size: itemsPerPage,
          sortBy: sortBy.join(","),
          sortOrder: sortDesc.map((s) => (s ? "desc" : "asc")).join(","),
          search: this.search || undefined,
        },
      });
      this.participants = result.rows;
      this.totalItems = result.count;
      this.loading = false;
    },
    async exportDownload() {
      this.$axios({
        url: `admin/participants/${this.currentActivity.id}/excelReport`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        fileDownload(
          response,
          `${this.currentActivity.name} - ${i18n.t("activities.participantsList.exportFileName")}.xlsx`
        );
      });
    },
  },
  watch: {
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    search: {
      handler() {
        debounce(this.loadData);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
